import { ArrowPathIcon } from '@heroicons/react/24/outline';

import { Icon } from '@/components/core/Icon';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * React equivalent of the AngularJS `<dm-deployment-in-progress>` directive
 * (webapp/app/directives/directives.js#4882 → tpl/datamodel-deployment-in-progress.tpl.html).
 *
 * Shown while an initial data model deployment is running for an
 * organization that has never had a data model deployed before (see
 * `application-controller.js#blockDuringDataModelDeployment`, which is
 * true when `organization.isDataModelDeploying && !organization.dataModelHash`).
 * The user must not interact with items during this window.
 */
const DeploymentInProgress = () => {
    const { t } = useTranslation();
    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-52 tw-space-y-7">
            <Icon size="3xl" icon={ArrowPathIcon} className="tw-animate-spin" />
            <h1>{t('NODATA.DATAMODEL_DEPLOY_IN_PROGRESS')}</h1>
        </div>
    );
};

DeploymentInProgress.DisplayName = 'DeploymentInProgress';

export { DeploymentInProgress };
